import React, { useState } from 'react';
import './TargetProductionModal.css';

function TargetProductionModal({ isOpen, onClose, onSave, currentValue }) {
  const [targetProduction, setTargetProduction] = useState(currentValue || '');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    // 유효성 검사
    if (!targetProduction || targetProduction === '') {
      setError('목표 생산량을 입력해주세요');
      return;
    }

    const value = parseInt(targetProduction, 10);
    if (isNaN(value) || value < 0) {
      setError('유효한 숫자를 입력해주세요');
      return;
    }

    setError('');
    setLoading(true);

    try {
      await onSave(value);
      onClose();
    } catch (err) {
      setError(err.message || '저장에 실패했습니다');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSave();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>목표 생산량 설정</h3>
          <button className="modal-close-btn" onClick={onClose}>
            <span className="material-symbols-outlined">close</span>
          </button>
        </div>

        <div className="modal-body">
          <div className="form-group">
            <label htmlFor="targetProduction">목표 생산량 (EA)</label>
            <input
              id="targetProduction"
              type="number"
              className="form-input"
              value={targetProduction}
              onChange={(e) => setTargetProduction(e.target.value)}
              onKeyPress={handleKeyPress}
              placeholder="목표 생산량을 입력하세요"
              min="0"
              autoFocus
            />
            {error && <div className="error-message">{error}</div>}
          </div>
        </div>

        <div className="modal-footer">
          <button className="btn-cancel" onClick={onClose} disabled={loading}>
            취소
          </button>
          <button className="btn-save" onClick={handleSave} disabled={loading}>
            {loading ? '저장 중...' : '저장'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default TargetProductionModal;
